<template>
  <bita-modal
    id="activity-form"
    title="گزارش فعالیت راننده"
    :modal-lg="true"
    :isLoading="isLoadingModal"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-grid
        v-if="showGrid"
        ref="logGrid"
        :columns="gridColumns"
        :read-data="readData"
        :hasRow="false"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  data() {
    return {
      isLoadingModal: false,
      showGrid: false,
      driver: {},
      filters: {},
      statuses: [
        { id: 1, name: "کنسلی" },
        { id: 2, name: "رزرو" },
      ],
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          title: "مبدا",
          template: (e) =>
            e.request && e.request.origin_name ? e.request.origin_name : "-",
          width: "100px",
        },
        {
          title: "مقصد",
          template: (e) =>
            e.request && e.request.destination_name
              ? e.request.destination_name
              : "-",
          width: "100px",
        },
        {
          title: "تاریخ بارگیری",
          template: (e) =>
            e.request && e.request.loading_at
              ? this.$getJalaliDate(e.request.loading_at)
              : "-",
          width: "100px",
        },
        {
          title: "سالن",
          template: (e) =>
            e.request && e.request.salon_name ? e.request.salon_name : "-",
          width: "130px",
        },
        {
          title: "وضعیت",
          template: (e) => (e.status_text ? e.status_text : "-"),
          width: "100px",
        },
        {
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "-",
          width: "140px",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: "50px",
        },
      ];
    },
  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "view",
        click: this.view,
        template: this.gridButtons.view,
      });
      return commands;
    },
    view(e) {
      let request = this.$refs.logGrid.getSelectedGridRow(e).request;

      window.open(`/management/request/${request.id}/detail`, "_blank");
    },
    setInitialData(_driver) {
      this.showGrid = true;
      this.driver = _driver;
    },
    readData(e) {
      this.isLoadingModal = true;
      let baseUrl = `drivers/${this.driver.id}/request-ticket-logs`,
        url = this.$makeQueryString(baseUrl, this.filters);
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => e.success([]))
        .finally(() => (this.isLoadingModal = false));
    },
    loadData() {
      this.$refs.logGrid.loadDataSource();
    },
    onCloseModal() {
      this.filters = {};
      this.showGrid = false;
    },
  },
};
</script>
